// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_ba-0";
export var headerCellHover = "_ba-1";